import $ from 'jquery';

// autokanaで window.jQueryを参照しているためwindowに生やしておく
// cf. https://stackoverflow.com/questions/35358625/jquery-is-not-defined-when-use-es6-import/39820703#39820703
window.jQuery = $;
